<script>
  import ChosenField from 'components/chosen-field'
  import ImageField from 'components/image-field'
  import MultipleImageField from 'components/multiple-image-field'
  import LocationField from 'components/location-field'
  import LocationFields from 'components/location-fields'
  import SkillsField from 'components/skills-field'
  import CollaboratorField from 'components/collaborator-field'
  import Modal from 'components/modal'
  import SocialLinks from 'components/social-links'
  import AtsEditForm from "../components/ats-edit-form";
  import CompanyCard from '../components/company-card'

  export default {
    props: {
      company: Object
    },
    template: '#js-company',
    components: {
      ChosenField,
      ImageField,
      MultipleImageField,
      LocationField,
      LocationFields,
      SkillsField,
      CollaboratorField,
      Modal,
      SocialLinks,
      AtsEditForm,
      CompanyCard
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/company/dom-template.vue?7f406171